import { Box, Chip, Typography } from "@mui/material"
import handleCopiarTexto from "../../helpers/handleCopiarTexto";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function ChipComCopyIcon({
  title,
  codigo,
}: ChipComCopyIconProps) {

  return (
    <Box
      display="flex"
      gap={1}
      alignItems="center"
      bgcolor="#e3e3e3"
      borderRadius={2.5}
      padding={1}
      onClick={() => handleCopiarTexto(codigo)}
      sx={{
        cursor: "pointer",
        '&:hover': {
          opacity: 0.7
        }
      }}
    >
      <Typography
        variant="body1"
        width={435}
        noWrap 
        sx={{
          overflow: 'hidden', 
          textOverflow: 'ellipsis'
        }}
      >
        {codigo}
      </Typography>
      <ContentCopyIcon color="primary" />
    </Box>
  )
}

interface ChipComCopyIconProps {
  title: string;
  codigo: string
}
